import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import AssetsDashboard from "./Component/Pages/AssetsDashboard";
import DetailedAsset from "./Component/Pages/DetailedAsset";
import { useSelector } from "react-redux";
import DefaultLayout from "./Component/Layout/DefaultLayout";
import { getWindowDimensions } from "./utils/common";

const Router = ({ defaultRoute }) => {
  const configData = useSelector((state) => state.configSlice);
  let navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const [screenMobile, setScreenMobile] = useState(true);

  useEffect(() => {
    if (defaultRoute) navigate(defaultRoute);
  }, [defaultRoute]);

  const handleResize = () => {
    const { mode } = getWindowDimensions();
    setScreenMobile(mode === "Landscape" ? false : true);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Routes>
      <Route
        path="/category/:id"
        element={
          <DefaultLayout>
            <AssetsDashboard />
          </DefaultLayout>
        }
      />
      <Route
        path="/asset/details/:id"
        element={
          <DefaultLayout sideBarVisible={false} screenMobile={!screenMobile} showSearch={false}>
            <DetailedAsset />
          </DefaultLayout>
        }
      />
      <Route path="*" element={<Navigate to={`/category/${configData.config["3dAssetsId"]}`} />} />
    </Routes>
  );
};

export default Router;
